import { defineMessages, FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';
import { formMessages } from '@/messages/forms';

const intlPrefix = 'checkout';

export const ShippingAddress = (
  <FormattedMessage {...commonMessages.shippingAddress} />
);

export const BillingAddress = (
  <FormattedMessage {...commonMessages.billingAddress} />
);

export const DifferentBilling = (
  <FormattedMessage
    defaultMessage='Enter different billing address'
    id='checkout.delivery.billingAddress.different'
  />
);

export const ContinueToOrderReview = (
  <FormattedMessage
    defaultMessage='Continue to order review'
    id='checkout.delivery.continue'
  />
);

export const DeliveryOption = (
  <FormattedMessage
    defaultMessage='Select your delivery option'
    id='checkout.delivery.selectOption'
  />
);

export const PersonalizeYourGiftMessage = (
  <FormattedMessage
    defaultMessage='Personalize your gift message.'
    id='checkout.delivery.gift.title'
  />
);

export const RemainingCharacters = (
  <FormattedMessage
    defaultMessage='Remaining characters'
    id='checkout.delivery.gift.remaining'
  />
);

export const ContactInformation = (
  <FormattedMessage
    defaultMessage='Contact information'
    id='checkout.delivery.contact'
  />
);

export const ContactInformationDescription = (
  <FormattedMessage
    defaultMessage='This will be used to confirm your order information and delivery.'
    id='checkout.delivery.contact.description'
  />
);

export const MandatoryFields = (
  <FormattedMessage {...formMessages.mandatoryFields} />
);

export const AddNewAddress = (
  <FormattedMessage
    defaultMessage='Add a new address'
    id='checkout.delivery.addNewAddress'
  />
);

export const DeliveryScheduleDescriptionForHomeDelivery = (
  <FormattedMessage
    defaultMessage='Once shipped, order should be delivered within 2-3 business days.'
    id={`${intlPrefix}.deliveryScheduleDescriptionForHomeDelivery`}
  />
);

export const EmailRegistered = (
  <FormattedMessage
    defaultMessage='The email is already registered'
    id='checkout.delivery.emailRegistered'
  />
);

export const LogInNow = (
  <FormattedMessage
    defaultMessage='Log in now'
    id='checkout.delivery.logInNow'
  />
);

export const ForGwp = (
  <FormattedMessage
    defaultMessage='for a exclusive complimentary gift at checkout'
    id='checkout.delivery.forGwp'
  />
);

export const messages = defineMessages({
  cembraKindReminder: {
    id: 'checkout.delivery.cembraKindReminder',
    defaultMessage:
      'Kind reminder: If you plan to use 0% financing or Purchase by Open Invoice as your payment method, the billing and shipping address must match',
  },
  v12KindReminder: {
    id: 'checkout.delivery.v12KindReminder',
    defaultMessage:
      'Kind reminder: If you plan to Pay with Interest-Free Credit as your payment method, we will only deliver to the address on the finance agreement.',
  },
});
export const TimeSlotLabelMessages = defineMessages({
  before9: {
    id: 'checkout.delivery.scheduleLabel.before9',
    defaultMessage: 'Before 9:00 (Mon-Sat)',
  },
  between9And12: {
    id: 'checkout.delivery.scheduleLabel.between9And12',
    defaultMessage: '9:00 - 12:00 (Mon-Sat)',
  },
  between11And14: {
    id: 'checkout.delivery.scheduleLabel.between11And14',
    defaultMessage: '11:00 - 14:00 (Mon-Fri)',
  },
  between17And20: {
    id: 'checkout.delivery.scheduleLabel.between17And20',
    defaultMessage: '17:00 - 20:00 (Mon-Fri)',
  },
});
